import type { ResultStrategy } from './ResultStrategy';
import { BacktestStrategy } from './BacktestStrategy';
import { TimeSeriesStrategy } from './TimeSeriesStrategy';
import { PnLStrategy } from './PnLStrategy';
import { VarianceStrategy } from './VarianceStrategy';
import { MeepMeepStrategy } from './MeepMeepStrategy';

const strategies: ResultStrategy[] = [
    new MeepMeepStrategy(),
    new BacktestStrategy(),
    new PnLStrategy(),
    new VarianceStrategy(),
    new TimeSeriesStrategy() // Fallback strategy usually placed last implicitly by matching logic
];

const fallback = new TimeSeriesStrategy();

export function getStrategy(nature?: string): ResultStrategy {
    const matched = strategies.find(s => s.match(nature));
    return matched || fallback;
}

export * from './ResultStrategy';
// Also exporting default widgets for types safety if needed
